import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap, BarChart3, Eye } from 'lucide-react';
export function Pricing() {
  const features = [{
    icon: <Zap className="w-4 h-4" data-id="element-194" />,
    text: 'Análisis de partidos con IA en tiempo real'
  }, {
    icon: <BarChart3 className="w-4 h-4" data-id="element-195" />,
    text: 'Modelado probabilístico de resultados'
  }, {
    icon: <Check className="w-4 h-4" data-id="element-196" />,
    text: 'Seguimiento contextual del rendimiento'
  }, {
    icon: <Eye className="w-4 h-4" data-id="element-197" />,
    text: 'Lectura estructural del juego'
  }];
  return <section id="pricing" className="py-12 md:py-16 px-4 relative" data-id="element-198">
      <div className="max-w-2xl mx-auto" data-id="element-199">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="glass-panel rounded-3xl p-8 md:p-12 relative overflow-hidden border-brand-green/30" data-id="element-200">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-brand-green/10 blur-[100px] pointer-events-none" data-id="element-201" />

          <div className="relative z-10" data-id="element-202">
            {/* Header */}
            <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.3em] text-brand-blue mb-2" data-id="element-203">
              <Lock className="w-3 h-3" data-id="element-204" />
              ACCESO PRIVADO
            </div>
            <div className="mb-8" data-id="element-205">
              <img src="https://i.postimg.cc/7Z06kXm2/Gemini-Generated-Image-e5q1v8e5q1v8e5q1-removebg-preview.png" alt="VISIONGOL" className="h-10 md:h-12 w-auto" data-id="element-206" />
            </div>

            {/* Price */}
            <div className="flex items-baseline gap-3 mb-2" data-id="element-207">
              <div className="text-5xl md:text-7xl font-display font-bold text-white text-glow-green" data-id="element-208">
                $6.36
              </div>
              <div className="text-lg text-gray-400 font-medium" data-id="element-209">USD</div>
            </div>
            <p className="text-sm text-gray-500 mb-8 font-mono uppercase tracking-wider" data-id="element-210">
              Entrada inmediata
            </p>

            {/* Features */}
            <div className="space-y-3 mb-8" data-id="element-211">
              {features.map((f, i) => <div key={i} className="flex items-center gap-3 text-gray-300" data-id="element-212">
                  <div className="w-8 h-8 rounded-lg bg-brand-green/10 border border-brand-green/20 text-brand-green flex items-center justify-center shrink-0" data-id="element-213">
                    {f.icon}
                  </div>
                  <span className="text-base" data-id="element-214">{f.text}</span>
                </div>)}
            </div>

            <div className="flex items-center gap-2 text-xs text-gray-500 font-mono mb-6 pb-6 border-b border-white/5" data-id="element-215">
              <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-216" />
              Disponible 24/7 · Actualización continua
            </div>

            {/* CTA */}
            <a href="https://www.apexdeporte.online/cart/51609047564576:1" target="_blank" rel="noopener noreferrer" className="btn-primary w-full px-6 py-5 rounded-2xl font-display font-bold text-lg md:text-xl uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-217">
              [ ACCEDER A VISIONGOL ]
            </a>

            <p className="text-center text-xs text-gray-500 mt-4 font-mono" data-id="element-218">
              El terminal privado se abre inmediatamente tras la entrada.
            </p>

            {/* Payment methods */}
            <div className="flex justify-center items-center mt-8 pt-6 border-t border-white/5" data-id="element-219">
              <img src="https://i.postimg.cc/Bvbn1NMc/paymentmethods-1671197681574.png" alt="Métodos de pago aceptados" className="max-w-full h-auto opacity-80" data-id="element-220" />
            </div>
          </div>
        </motion.div>

        {/* Image below pricing card */}
        <div className="flex justify-center items-center mt-8" data-id="element-221">
          <img src="https://i.postimg.cc/qvjVf327/Easy-Bite-Kids-Logo-with-Spoon-Icon.png" alt="" className="max-w-xs w-full h-auto" data-id="element-222" />
        </div>
      </div>
    </section>;
}